import { render, staticRenderFns } from "./SwapSales.vue?vue&type=template&id=fbbcfc4c&"
import script from "./SwapSales.vue?vue&type=script&lang=js&"
export * from "./SwapSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports